import { RouteConfig } from 'src/routing/types'

const ROUTE: RouteConfig = {
  name: 'code-of-conduct',
  path: () => '/code-of-conduct',
}

export default ROUTE
